<template>
  <div>
    <!--
    <div>loadings[{{ loadings }}]</div>
    <div>isLoading[{{ isLoading }}]</div>
    <div>getDbErrors[{{ getDbErrors }}]</div>
    <div>origin[{{ field.origin }}]</div>
    -->
    <template v-if="isLoading">
      {{ $t('general.loading') }}...
    </template>
    <template v-else-if="getDbErrors">
      {{ getDbErrors }}
    </template>
    <template v-else>
      <v-autocomplete
        v-validate="field.validation" 
        v-model="componentValue"
        :name="field.name"
        :items="itemOptions"
        :label="$t(`entity.${entity}.${field.name}.label`)"
        :error="hasError(field.name)"
        :error-messages="getError(field.name)"
        :prepend-icon="field.icon"
        :disabled="item && !field.allowEdit"
        item-text="text"
        item-value="value"
      />
    </template>
  </div>
</template>

<script>
import bus from '@/components/Base/bus'
import SportHelper from '@/lib/SportHelper'
import SportClubsLib from '@/lib/data/sportClubs'
const debug = require('debug')('OD::BaseFormSelect')

export default {
  name: 'BaseFormSelect',
  props: {
    entity: {
      type: String,
      required: true,
    },
    field: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      componentValue: '',
      sports: [],
      clubSports: [],
      sportClubs: [],
      loadings: {
        sportClubs: true,
      },
      dbErrors: {
        sportClubs: null,
      },
    }
  },
  computed: {
    itemOptions() {
      const options = []
      if (this.items && !this.loadings[this.field.origin]) {
        this.items.forEach(item => {
          options.push({
            value: item.id,
            text: item.name,
          })
        })
      }
      return options
    },
    items() {
      let items = []
      if (!this.loadings[this.field.origin]) {
        items = this[this.field.origin]
      }
      return items
    },
    isLoading() {
      return this.loadings[this.field.origin]
    },
    getDbErrors() {
      return this.dbErrors[this.field.origin]
    },
    sportId() {
      return this.$route.params.sportId
    },
  },
  watch: {
    componentValue() {
      this.$emit('update:value', this.componentValue)
    },
    sportId() {
      this.bind()
    },
  },
  created() {
    this.init()
  },
  mounted() {
    bus.$on('validate', this.onValidate)
    this.bind()
  },
  beforeDestroy() {
    bus.$off('validate', this.onValidate)
  },
  methods: {
    init() {
      this.componentValue = this.item ? this.item[this.field.name] : null
      // this.$store.dispatch(`${this.field.origin}/init`, this.$route.params)
    },
    bind() {
      switch (this.field.origin) {
        case 'sports':
          this.sports = SportHelper.getSportList().map(sport => {
            return {
              id: sport,
              name: this.$t(`sport.types.${sport}.name`),
            }
          })
          break
        case 'clubSports':
          this.clubSports = SportHelper.getClubSportList().map(sport => {
            return {
              id: sport,
              name: this.$t(`sport.types.${sport}.name`),
            }
          })
          break
        case 'sportClubs':
          SportClubsLib.bindAll(this, { sportId: this.$route.params.sportId })
          break
      }
    },
    hasError(key) {
      return !!this.errors.first(key)
    },
    getError(key) {
      return this.errors.first(key) ? [this.errors.first(key)] : []
    },
    onValidate() {
      this.$validator.validateAll()
    },
  },
}
</script>

<style scoped>
</style>
